module.exports = __webpack_public_path__ + "static/media/marshall-Islands.15e740f7.svg";